"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stableIsotopesObject = void 0;
const elementsAndIsotopes_js_1 = require("./elementsAndIsotopes.js");
exports.stableIsotopesObject = {};
for (const element of elementsAndIsotopes_js_1.elementsAndIsotopes) {
    let abundance = 0;
    let mostAbundant = 0;
    for (const isotope of element.isotopes) {
        if (typeof isotope.abundance === 'number' &&
            isotope.abundance > abundance) {
            abundance = isotope.abundance;
            mostAbundant = isotope.nominal;
        }
    }
    for (const isotope of element.isotopes) {
        if (isotope.abundance === 0)
            continue;
        const entry = {
            name: element.name,
            mass: isotope.mass,
            symbol: element.symbol,
            mostAbundant: false,
            deltaNeutrons: isotope.nominal - mostAbundant,
        };
        if (isotope.nominal === mostAbundant) {
            entry.mostAbundant = true;
        }
        exports.stableIsotopesObject[`${isotope.nominal}${element.symbol}`] = entry;
    }
}
//# sourceMappingURL=stableIsotopesObject.js.map